(()=>{
  const ROOT='[data-axion-configurator][data-product-handle="axion-designer-ps5"]';
  const CUSTOM='Colori Personalizzati';
  const EDIT_AESTHETIC_LABELS={
    face:'Bottoni Frontali',dpad:'Frecce Direzionali',share:'Options & Share',sticks:'Analogici',rings:'Anelli Analogici',
    touch:'Touchpad',ps:'Bottone PS',mic:'Microfono',bumpers:'Bumpers',triggers:'Triggers'
  };
  const isCustomValue=value=>String(value||'').toLowerCase().includes('personalizzat');

  // Keep the 3D model untouched. This patch only restores the visual material
  // palette from the OEM reference pack supplied for the configurator.
  const PARTS={
    shell:['AXION_SHELL__VRayMtl55','AXION_SHELL__front_body'],
    face:['AXION_FACE__Material.002'],
    faceBody:['AXION_FACE_BODY__SOLID'],
    dpad:['AXION_DPAD__Material.002','AXION_DPAD__Material.009','AXION_DPAD__material_0'],
    share:['AXION_SMALL__Material.007'],
    sticks:['AXION_STICKS__VRayMtl33'],
    rings:['AXION_RINGS__front_body.002'],
    touch:['AXION_TOUCHPAD__front_body'],
    ps:['AXION_SMALL__Material.005'],
    mic:['AXION_SMALL__Material'],
    bumpers:['AXION_BUMPERS__VRayMtl37'],
    triggers:['AXION_TRIGGERS__VRayMtl37'],
    psMount:['AXION_PS_MOUNT__BLACK']
  };

  const SHELL={
    'Chroma Indigo':'#44378f',
    'Chroma Pearl':'#e5e0d5',
    'Black':'#0e1115',
    'Volcano Red':'#ac1520',
    'White':'#e9e7df',
    'Starlight Blue':'#56a5d9',
    'Sterling Silver':'#a6adb4',
    'Cosmic Red':'#ad2445',
    'Galactic Purple':'#7250a6',
    'Grey Camouflage':'#666b70'
  };

  const DARK='#111318';
  const DARK2='#171a20';
  const OEM_SHOULDERS='#23252B';
  const SMART_RESIN_BLACK='#101215';

  const OEM={
    'Black':{
      face:'#0d0f12',faceBody:'#080a0d',dpad:'#0d0f12',share:'#101216',
      sticks:'#080a0d',rings:'#0b0d10',touch:'#0d0f12',ps:'#080a0d',mic:'#0b0d10',
      bumpers:'#0b0d10',triggers:'#0b0d10',psMount:'#080a0d'
    },
    'White':{
      face:'#e4e5e7',faceBody:DARK,dpad:'#e4e5e7',share:'#e3e4e6',
      sticks:DARK2,rings:DARK,touch:'#e7e7e8',ps:DARK,mic:DARK,
      bumpers:OEM_SHOULDERS,triggers:OEM_SHOULDERS,psMount:DARK
    },
    'Cosmic Red':{
      face:'#9b173f',faceBody:DARK,dpad:'#9b173f',share:'#a51a45',
      sticks:DARK2,rings:DARK,touch:'#a91d49',ps:DARK,mic:DARK,
      bumpers:OEM_SHOULDERS,triggers:OEM_SHOULDERS,psMount:DARK
    },
    'Volcano Red':{
      face:'#9e1028',faceBody:DARK,dpad:'#9e1028',share:'#a9132d',
      sticks:DARK2,rings:DARK,touch:'#b51432',ps:DARK,mic:DARK,
      bumpers:OEM_SHOULDERS,triggers:OEM_SHOULDERS,psMount:DARK
    },
    'Galactic Purple':{
      face:'#5433a0',faceBody:DARK,dpad:'#5433a0',share:'#5837a7',
      sticks:DARK2,rings:DARK,touch:'#5534a2',ps:DARK,mic:DARK,
      bumpers:OEM_SHOULDERS,triggers:OEM_SHOULDERS,psMount:DARK
    },
    'Starlight Blue':{
      face:'#55a8d8',faceBody:DARK,dpad:'#55a8d8',share:'#56addd',
      sticks:DARK2,rings:DARK,touch:'#58b2e2',ps:DARK,mic:DARK,
      bumpers:OEM_SHOULDERS,triggers:OEM_SHOULDERS,psMount:DARK
    },
    'Sterling Silver':{
      face:'#9ea8b2',faceBody:DARK,dpad:'#9ea8b2',share:'#a3adb7',
      sticks:DARK2,rings:DARK,touch:'#a9b2bb',ps:DARK,mic:DARK,
      bumpers:OEM_SHOULDERS,triggers:OEM_SHOULDERS,psMount:DARK
    },
    'Grey Camouflage':{
      face:'#0b0c0d',faceBody:'#11151c',dpad:'#090a0b',share:'#101113',
      sticks:'#111315',rings:'#0d0f10',touch:'#666b70',ps:'#090a0b',mic:'#0d0f10',
      bumpers:'#171a20',triggers:'#171a20',psMount:'#090a0b'
    },
    'Chroma Pearl':{
      face:'#d9d9e2',faceBody:'#c9cbd2',dpad:'#d9d9e2',share:'#dedee6',
      sticks:'#a8abb5',rings:'#c6c8cf',touch:'#e5e3ec',ps:'#c5c7cf',mic:'#c5c7cf',
      bumpers:'#d7d8df',triggers:'#d7d8df',psMount:'#c5c7cf'
    },
    'Chroma Indigo':{
      face:'#40345d',faceBody:'#342b46',dpad:'#40345d',share:'#41365e',
      sticks:'#3d334f',rings:'#3a304c',touch:'#5593e7',ps:'#3a304c',mic:'#382e49',
      bumpers:'#514667',triggers:'#514667',psMount:'#342b46'
    }
  };

  const lin=v=>{v/=255;return v<=0.04045?v/12.92:Math.pow((v+0.055)/1.055,2.4)};
  const rgba=hex=>{
    const h=String(hex||'#ffffff').replace('#','');
    return [lin(parseInt(h.slice(0,2),16)),lin(parseInt(h.slice(2,4),16)),lin(parseInt(h.slice(4,6),16)),1];
  };

  document.querySelectorAll(ROOT).forEach(root=>{
    if(root.dataset.axionOemZipRestore==='1')return;
    root.dataset.axionOemZipRestore='1';

    const viewer=root.querySelector('[data-axion-model-viewer]');
    const status=root.querySelector('[data-axion-model-status]');
    if(!viewer)return;

    root.dataset.axionFirstPaintGuard='1';
    root.dataset.axionFirstPaintReady='0';
    viewer.style.opacity='0';
    viewer.style.transition='none';
    viewer.style.willChange='opacity';

    const editPayload=root.__axionEditPayload&&typeof root.__axionEditPayload==='object'?root.__axionEditPayload:null;
    const editChoices=editPayload?.aesthetic&&typeof editPayload.aesthetic==='object'?editPayload.aesthetic:{};
    const editHasCustom=isCustomValue(editPayload?.aestheticMode)||Object.values(editChoices).some(choice=>isCustomValue(choice?.mode));
    const state={
      global:editHasCustom?CUSTOM:'Standard',
      modes:Object.fromEntries(Object.entries(EDIT_AESTHETIC_LABELS).map(([key,label])=>[
        key,isCustomValue(editChoices[label]?.mode)?CUSTOM:'Standard'
      ]))
    };
    let raf=0;
    let lateTimer=0;

    const shell=()=>root.querySelector('[data-shell-name]')?.textContent?.trim()
      || root.querySelector('[data-action="shell"].is-selected')?.dataset.value
      || 'Black';
    const materials=()=>viewer.model?.materials||[];
    const material=name=>materials().find(m=>m.name===name);
    const setColor=(names,hex)=>{
      if(!viewer.model||!hex)return;
      const factor=rgba(hex);
      names.forEach(name=>material(name)?.pbrMetallicRoughness?.setBaseColorFactor(factor));
    };
    const isCustom=key=>state.global===CUSTOM&&state.modes[key]===CUSTOM;
    const smartFaceActive=()=>{
      const selected=root.querySelector('[data-action="set"][data-key="smartFace"].is-selected');
      const value=selected?selected.dataset.value:editPayload?.performance?.dpadFaceButtons;
      return value==='Smart D-Pad & Face Buttons';
    };

    const revealFirstPaint=()=>{
      if(root.dataset.axionFirstPaintReady==='1')return;
      root.dataset.axionFirstPaintReady='1';
      viewer.style.transition='opacity .16s ease';
      requestAnimationFrame(()=>{
        viewer.style.opacity='1';
        setTimeout(()=>{viewer.style.willChange=''},220);
      });
    };

    const apply=()=>{
      raf=0;
      if(!viewer.model)return;
      const name=shell();
      const palette=OEM[name]||OEM.Black;

      if(name!=='Grey Camouflage')setColor(PARTS.shell,SHELL[name]||SHELL.Black);
      if(!isCustom('face'))setColor(PARTS.faceBody,palette.faceBody);

      ['face','dpad','share','sticks','rings','touch','ps','mic','bumpers','triggers'].forEach(key=>{
        if(!isCustom(key))setColor(PARTS[key],palette[key]);
      });
      if(!isCustom('ps'))setColor(PARTS.psMount,palette.psMount);

      if(typeof root.__axionSyncCustomMaterials==='function')root.__axionSyncCustomMaterials();

      // Smart D-Pad & Face Buttons changes the input hardware only.
      // Visual colors remain controlled by the customer's aesthetic choices.

      root.dataset.axionOemZipShell=name;
      if(status&&root.dataset.axionWebMasterV1Ready==='1'){
        status.textContent='3D LIVE · OEM ZIP BASELINE · RESTORED';
        status.classList.add('is-ready');
      }
      revealFirstPaint();
    };

    const schedule=()=>{
      if(raf)cancelAnimationFrame(raf);
      if(lateTimer)clearTimeout(lateTimer);
      // Final OEM/custom colors must settle before the browser paints.
      queueMicrotask(apply);
    };

    root.addEventListener('click',event=>{
      const btn=event.target.closest('button');
      if(btn?.classList.contains('axv3__devcart-add'))return;
      if(btn){
        if(btn.dataset.action==='set'&&btn.dataset.key==='aestheticMode')state.global=btn.dataset.value||'Standard';
        if(btn.dataset.action==='a-mode'&&btn.dataset.key)state.modes[btn.dataset.key]=btn.dataset.value||'Standard';
      }
      schedule();
    },true);
    root.addEventListener('change',schedule,true);

    const shellName=root.querySelector('[data-shell-name]');
    if(shellName)new MutationObserver(schedule).observe(shellName,{childList:true,subtree:true,characterData:true});

    viewer.addEventListener('load',()=>{
      schedule();
      setTimeout(apply,120);
      setTimeout(()=>{
        if(root.dataset.axionFirstPaintReady!=='1')revealFirstPaint();
      },700);
    });
    if(viewer.model)schedule();
  });
})();
